const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.accordion = this.querySelector("[data-accordion-item]");
    this.localizationSelector = this.querySelectorAll("[data-value]");
    this.country_code = this.querySelector("[data-country-code]");
    this.language_code = this.querySelector("[data-language-code]");
  }

  connectedCallback() {
    this.localizationSelector.forEach((selector) => {
      selector.addEventListener("click", () => {
        this.language_code.value = selector.dataset.langValue;
        this.country_code.value = selector.dataset.value;
        this.form.submit();
      });
    });
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}
